export default {
  BlackJack: '3:2',
  PlayerWins: '1:1',
  Insurance: '2:1',
  PerfectPair: '25:1',
  PerfectEleven: '21:1',
  AnyEleven: '10:1',
  PerfectElevenBlackjack: '5:1',
  TenTwenty: '22:1',
  TotalTen: '10:1',
  TotalTwenty: '3:1',
  ColoredPair: '12:1',
  MixedPair: '6:1',
  SuitedTrips: '100:1',
  StraightFlush: '40:1',
  ThreeOfAKind: '25:1',
  Straight: '10:1',
  Flush: '5:1',
};
